import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

export function AdminVehiclesGrid({ vehicles, onToggle }) {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {vehicles.map((v) => (
        <div key={v.id} data-testid={`admin-vehicle-${v.id}`} className="bg-white rounded-2xl shadow-card border border-border p-4 flex gap-3">
          <img src={v.photos?.[0]} alt="" className="w-24 h-20 object-cover rounded-xl bg-sand" />
          <div className="flex-1">
            <h3 className="font-heading font-bold text-ink text-sm">{v.brand} {v.model}</h3>
            <p className="text-xs text-muted2">{v.loueur_name} · {v.plate}</p>
            <p className="text-canard-dark font-bold text-sm mt-1">{v.price_per_day} €/j</p>
            <Button size="sm" variant="outline" data-testid={`toggle-vehicle-${v.id}`} onClick={() => onToggle(v)} className={`rounded-full h-7 mt-1 text-xs ${v.status === "active" ? "text-destructive border-destructive/30" : "text-emeraude-dark"}`}>
              {v.status === "active" ? t("dash.suspend") : t("dash.reactivate")}
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
}
